import * as React from 'react';
import type { AgentPromptTarget } from '@cdf/api-client-react';
import { Button } from '@/components/ui/button';
import { GENERAL_PROMPT_TARGETS, promptTargetLabel, type PromptTargetOption } from './prompt-library-context';

export function AgentPromptTargets({ value, options, disabled, onChange }: {
  value: AgentPromptTarget[];
  options: readonly PromptTargetOption[];
  disabled: boolean;
  onChange: (value: AgentPromptTarget[]) => void;
}) {
  const [selection, setSelection] = React.useState('');
  const choices = options.filter(option => !value.some(target => target.kind === option.target.kind && target.key === option.target.key));
  return <fieldset className="space-y-2 rounded-md border p-3" disabled={disabled}>
    <legend className="px-1 text-sm font-medium">Available in</legend>
    <p className="text-xs text-muted-foreground">General, or up to 20 functions and modules. Targeting never grants access to a function.</p>
    <ul className="space-y-1">{value.map(target => <li key={target.kind + ':' + (target.key ?? '')} className="flex items-center justify-between gap-2 text-sm">
      <span>{promptTargetLabel(target)}</span>
      {target.kind !== 'general' && <Button type="button" size="sm" variant="ghost" disabled={disabled} onClick={() => {
        const remaining = value.filter(item => item !== target);
        onChange(remaining.length ? remaining : GENERAL_PROMPT_TARGETS);
      }}>Remove {promptTargetLabel(target)}</Button>}
    </li>)}</ul>
    <label className="block text-sm">Add function or module<select aria-label="Add function or module" className="mt-1 w-full rounded-md border bg-background p-2" value={selection} disabled={disabled || value.length >= 20} onChange={event => setSelection(event.target.value)}>
      <option value="">Choose a target</option>
      {choices.map(option => <option key={option.target.kind + ':' + option.target.key} value={option.target.kind + ':' + option.target.key}>{option.label}</option>)}
    </select></label>
    <div className="flex flex-wrap gap-2">
      <Button type="button" variant="outline" size="sm" disabled={disabled || !selection || value.length >= 20} onClick={() => {
        const selected = choices.find(option => option.target.kind + ':' + option.target.key === selection);
        if (selected) { onChange([...value.filter(target => target.kind !== 'general'), selected.target]); setSelection(''); }
      }}>Add target</Button>
      <Button type="button" variant="ghost" size="sm" disabled={disabled || value[0]?.kind === 'general'} onClick={() => onChange(GENERAL_PROMPT_TARGETS)}>Use General</Button>
    </div>
  </fieldset>;
}
